export const storeList = [
    { key: 'WALTHAM', value: 1 },
    { key: 'FITCHBURG', value: 4 },
    { key: 'BROCKTON', value: 5 }
  ];

export const STORE_STORAGE_KEY = 'selected_store_id';

export const getStoredStoreId = () => {
  return localStorage.getItem(STORE_STORAGE_KEY) || '';
};

export const setStoredStoreId = (storeId) => {
  if (storeId !== undefined && storeId !== null && storeId !== '') {
    localStorage.setItem(STORE_STORAGE_KEY, String(storeId));
  } else {
    localStorage.removeItem(STORE_STORAGE_KEY);
  }
};